var _ellipse, _ellipse2, _ellipse3, _path, _ellipse4, _path2, _mask, _g, _ellipse5, _ellipse6, _path3, _ellipse7, _ellipse8, _path4, _path5, _path6, _path7, _path8, _path9, _mask2, _g2, _rect, _path10, _path11, _rect2, _path12, _circle, _path13, _circle2, _path14, _ellipse9, _path15, _path16, _path17, _ellipse10, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _ellipse11, _ellipse12, _ellipse13, _path25, _path26, _ellipse14, _ellipse15, _ellipse16;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStandingOnIsland(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 788,
    height: 185,
    viewBox: "0 0 788 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 381.169,
    cy: 157.606,
    rx: 2.40252,
    ry: 0.961009,
    fill: "#EEE9C8"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 385.374,
    cy: 159.528,
    rx: 1.32139,
    ry: 0.480505,
    fill: "#EEE9C8"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 381.529,
    cy: 159.407,
    rx: 0.840883,
    ry: 0.360378,
    fill: "#EEE9C8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00264205 154.169C-0.351357 158.053 34.9048 162.251 83.5418 165.221C118.425 167.351 171.73 168.014 225.339 168.68C244.631 168.92 263.963 169.161 282.49 169.47C302.219 169.8 322.099 170.267 341.991 170.735L341.991 170.735C392.656 171.925 443.399 173.118 491.926 172.043C531.689 171.162 545.683 169.004 560.074 166.784C570.193 165.224 580.509 163.633 600.119 162.434C621.998 161.097 653.454 160.174 684.344 159.267C729.427 157.943 773.302 156.655 784.427 154.169C803.181 149.978 744.675 145.787 688.96 142.582C636.88 139.586 562.221 138.16 487.074 137.064C414.638 136.007 339.26 135.324 267.076 136.426C193.652 137.547 128.711 139.936 85.5496 143.193C43.2008 146.387 0.35514 150.302 0.00264205 154.169ZM544.461 174.948C554.543 174.948 572.608 173.92 597.69 172.493L597.691 172.493C613.077 171.618 631.104 170.592 651.546 169.562C705.315 166.851 868.335 158.557 724.969 160.941C617.289 162.732 615.414 163.617 612.25 165.111C611.201 165.606 610.011 166.167 604.781 166.851C597.903 167.751 585.785 168.929 573.669 170.108C548.778 172.528 523.896 174.948 544.461 174.948ZM356.95 177.433C297.985 175.174 222.077 175.313 269.52 180.778C316.963 186.244 410.802 185.54 471.987 180.778C507.399 178.022 483.038 178.092 444.8 178.202C416.969 178.283 381.788 178.384 356.95 177.433ZM667.174 153.478C684.726 153.478 698.02 151.804 698.02 149.739C698.02 147.674 683.791 146 666.24 146C648.688 146 621 147.674 621 149.739C621 151.267 631.655 151.762 648.034 152.523C653.781 152.79 660.232 153.089 667.174 153.478ZM665.305 151.608C679.243 151.608 690.542 150.562 690.542 149.272C690.542 148.087 681.028 147.109 668.691 146.956C676.821 147.095 683.065 147.919 683.065 148.914C683.065 150.007 676.027 150.894 666.735 150.894C657.443 150.894 649.415 150.007 649.415 148.914C649.415 147.836 656.737 146.96 665.847 146.935C665.667 146.935 665.486 146.935 665.305 146.935C651.367 146.935 640.068 147.981 640.068 149.272C640.068 150.562 651.367 151.608 665.305 151.608ZM677.126 148.667C677.126 149.35 672.141 149.904 665.992 149.904C659.843 149.904 654.858 149.35 654.858 148.667C654.858 147.984 659.843 147.43 665.992 147.43C672.141 147.43 677.126 147.984 677.126 148.667ZM163 147.5C156.5 147.5 151 146.918 151 145.524C151 144.13 160.606 143 172.456 143C184.306 143 195 144.13 195 145.524C195 146.918 169.5 147.5 163 147.5ZM173.087 146.786C163.677 146.786 156.049 146.08 156.049 145.209C156.049 144.472 161.498 143.854 168.866 143.68C163.231 143.837 159.096 144.354 159.096 144.967C159.096 145.706 164.685 146.304 172.063 146.304C179.441 146.304 185.815 145.706 185.815 144.967C185.815 144.239 179.99 143.647 172.747 143.631C172.86 143.631 172.974 143.631 173.087 143.631C182.498 143.631 190.126 144.337 190.126 145.209C190.126 146.08 182.498 146.786 173.087 146.786ZM163.813 144.8C163.813 145.262 167.771 145.636 172.653 145.636C177.536 145.636 181.494 145.262 181.494 144.8C181.494 144.339 177.536 143.965 172.653 143.965C167.771 143.965 163.813 144.339 163.813 144.8Z",
    fill: "#DEFBFF"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 363.551,
    cy: 153.309,
    rx: 148.551,
    ry: 7.60952,
    fill: "#93CFF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M509.257 151.64C509.48 151.765 509.539 151.967 509.49 152.155C509.441 152.35 509.275 152.525 509.004 152.547C417.835 159.892 364.989 159.247 272.729 152.525C272.455 152.505 272.288 152.331 272.237 152.136C272.188 151.948 272.245 151.746 272.468 151.621C284.102 145.108 332.691 120.021 390.846 120.021C449.058 120.021 497.685 145.157 509.257 151.64Z",
    fill: "#FFFDF1",
    stroke: "#003792",
    strokeWidth: 0.916451
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 271,
    y: 119,
    width: 239,
    height: 40
  }, /*#__PURE__*/React.createElement("path", {
    d: "M509.257 151.64C509.48 151.765 509.539 151.967 509.49 152.155C509.441 152.35 509.275 152.525 509.004 152.547C417.835 159.892 364.989 159.247 272.729 152.525C272.455 152.505 272.288 152.331 272.237 152.136C272.188 151.948 272.245 151.746 272.468 151.621C284.102 145.108 332.691 120.021 390.846 120.021C449.058 120.021 497.685 145.157 509.257 151.64Z",
    fill: "#FFFDF1",
    stroke: "#003792",
    strokeWidth: 0.916451
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.479 152.974C270.686 152.849 270.316 151.938 270.886 151.374C277.233 145.099 308.141 119.563 390.846 119.563C363.773 120.118 313.157 129.558 323.292 159.022C323.485 159.582 323.166 160.228 322.59 160.37C295.317 167.127 284.307 154.989 271.479 152.974Z",
    fill: "#EEE9C8"
  }))), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 394.981,
    cy: 132.466,
    rx: 3.30849,
    ry: 1.32339,
    fill: "#EEE9C8"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 393,
    cy: 123.5,
    rx: 28,
    ry: 3.5,
    fill: "#EEE9C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M508.419 151.956C508.47 151.985 508.477 152.007 508.478 152.009C508.481 152.017 508.485 152.036 508.478 152.066C508.47 152.096 508.453 152.123 508.43 152.143C508.411 152.16 508.378 152.181 508.313 152.186C417.165 159.53 364.338 158.885 272.093 152.164C272.027 152.16 271.993 152.139 271.973 152.122C271.95 152.102 271.932 152.074 271.925 152.044C271.917 152.015 271.921 151.996 271.924 151.989L271.924 151.989C271.925 151.986 271.933 151.965 271.983 151.937C283.598 145.434 332.122 120.383 390.184 120.383C448.303 120.383 496.864 145.483 508.419 151.956Z",
    stroke: "#003792",
    strokeWidth: 1.64
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400.771,
    cy: 135.113,
    rx: 1.81967,
    ry: 0.661697,
    fill: "#EEE9C8"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 395.478,
    cy: 134.947,
    rx: 1.15797,
    ry: 0.496273,
    fill: "#EEE9C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M450.452 134.185C449.293 133.013 450.732 131.14 452.163 131.96L455.779 134.03C456.115 134.223 456.495 134.324 456.883 134.324L463.528 134.324C464.151 134.324 464.55 134.988 464.257 135.538C463.637 136.7 464.04 138.143 465.172 138.817L470.524 142.001C471.83 142.779 471.279 144.783 469.759 144.783L464.675 144.783C463.159 144.783 461.86 145.868 461.59 147.36L460.918 151.073C460.651 152.544 458.629 152.758 458.062 151.374L455.688 145.588C455.232 144.474 454.178 143.72 452.977 143.647L447.015 143.286C445.676 143.205 445.112 141.539 446.127 140.661L450.343 137.014C451.191 136.28 451.241 134.982 450.452 134.185Z",
    fill: "#F0E59A",
    stroke: "#003792",
    strokeWidth: 1.64
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M411.785 122.666H386.795L390.46 74.4947H407.112V117.427V117.78L407.368 118.024L407.368 118.024L407.369 118.024L407.371 118.026L407.379 118.034L407.413 118.066C407.443 118.095 407.487 118.138 407.545 118.193C407.659 118.303 407.824 118.463 408.027 118.663C408.433 119.061 408.988 119.615 409.584 120.233C410.343 121.021 411.142 121.888 411.785 122.666Z",
    fill: "white",
    stroke: "#003792",
    strokeWidth: 1.64423
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M400.094 122.666C399.973 122.448 399.805 122.215 399.586 121.969C399.076 121.396 398.371 120.845 397.63 120.357C396.894 119.873 396.153 119.471 395.593 119.189C395.314 119.049 395.083 118.939 394.922 118.866C394.841 118.829 394.779 118.801 394.737 118.782L394.691 118.762L394.68 118.757L394.678 118.756L394.678 118.756L394.678 118.756L394.678 118.756L394.031 118.481L394.203 117.799L402.575 84.5429H378.929L377.178 122.666H400.094Z",
    fill: "white",
    stroke: "#003792",
    strokeWidth: 1.64423
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M378.694 74.8601H407.376V90.2603L400.115 93.1122L378.694 88.9168V74.8601Z",
    fill: "#003792",
    stroke: "#003792",
    strokeWidth: 0.913461
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M392.964 48.3729L392.965 48.2787L392.16 48.2506C390.178 48.1815 388.606 46.5376 388.636 44.5449C388.665 42.5271 390.325 40.9157 392.343 40.9456C392.38 40.9461 392.416 40.9472 392.452 40.9488L392.47 40.9496L392.488 40.9496C392.578 40.9497 392.668 40.9504 392.759 40.9517C403.324 41.1083 411.762 49.8002 411.606 60.3656C411.502 67.342 407.678 73.3921 402.046 76.6521L399.388 69.5461C402.253 67.4504 404.137 64.0809 404.193 60.2558C404.288 53.8895 399.287 48.6337 392.964 48.3729Z",
    fill: "white",
    stroke: "#003792",
    strokeWidth: 1.64423
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M378.9 45.6593C379.294 42.9161 381.645 40.8794 384.416 40.8794H391.525C400.556 40.8794 407.876 48.1999 407.876 57.2303V73.566L374.979 72.9597L378.9 45.6593Z",
    fill: "white",
    stroke: "#003792",
    strokeWidth: 1.64423
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 377,
    y: 40,
    width: 32,
    height: 35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M377.915 46.4515C377.915 43.3741 380.41 40.8794 383.487 40.8794H391.526C400.556 40.8794 407.877 48.1999 407.877 57.2303V73.5813H377.915V46.4515Z",
    fill: "#DEFBFF",
    stroke: "#003792",
    strokeWidth: 1.64423
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 379.139,
    y1: 92.6267,
    x2: 428.531,
    y2: 62.5604,
    stroke: "#003792",
    strokeWidth: 1.64423
  }), /*#__PURE__*/React.createElement("line", {
    x1: 377.253,
    y1: 89.5276,
    x2: 426.645,
    y2: 59.4614,
    stroke: "#003792",
    strokeWidth: 1.64423
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.366,
    y1: 86.4285,
    x2: 424.758,
    y2: 56.3622,
    stroke: "#003792",
    strokeWidth: 1.64423
  }), /*#__PURE__*/React.createElement("line", {
    x1: 373.48,
    y1: 83.3294,
    x2: 422.872,
    y2: 53.2632,
    stroke: "#003792",
    strokeWidth: 1.64423
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.593,
    y1: 80.2303,
    x2: 420.984,
    y2: 50.1641,
    stroke: "#003792",
    strokeWidth: 1.64423
  }), /*#__PURE__*/React.createElement("line", {
    x1: 369.707,
    y1: 77.1313,
    x2: 419.098,
    y2: 47.0651,
    stroke: "#003792",
    strokeWidth: 1.64423
  }), /*#__PURE__*/React.createElement("line", {
    x1: 367.821,
    y1: 74.0323,
    x2: 417.212,
    y2: 43.966,
    stroke: "#003792",
    strokeWidth: 1.64423
  }), /*#__PURE__*/React.createElement("line", {
    x1: 365.934,
    y1: 70.9331,
    x2: 415.325,
    y2: 40.8669,
    stroke: "#003792",
    strokeWidth: 1.64423
  }), /*#__PURE__*/React.createElement("line", {
    x1: 364.048,
    y1: 67.8341,
    x2: 413.439,
    y2: 37.7678,
    stroke: "#003792",
    strokeWidth: 1.64423
  }), /*#__PURE__*/React.createElement("line", {
    x1: 362.161,
    y1: 64.735,
    x2: 411.552,
    y2: 34.6687,
    stroke: "#003792",
    strokeWidth: 1.64423
  }), /*#__PURE__*/React.createElement("line", {
    x1: 360.274,
    y1: 61.636,
    x2: 409.666,
    y2: 31.5697,
    stroke: "#003792",
    strokeWidth: 1.64423
  }), /*#__PURE__*/React.createElement("line", {
    x1: 358.387,
    y1: 58.5369,
    x2: 407.779,
    y2: 28.4706,
    stroke: "#003792",
    strokeWidth: 1.64423
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 368.05,
    y: 70.4755,
    width: 49.875,
    height: 13.7019,
    rx: 6.85096,
    fill: "white",
    stroke: "#003792",
    strokeWidth: 1.64423
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M373.53 77.1499C373.535 75.0361 373.905 72.9477 374.628 70.2928H382.279C381.723 72.9896 381.414 75.1111 381.399 77.2345C381.384 79.3579 381.662 81.4795 382.276 84.1774H374.629C373.886 81.4095 373.526 79.2645 373.53 77.1499Z",
    fill: "#003792",
    stroke: "#003792",
    strokeWidth: 0.182692
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M414.818 77.235C414.816 75.1208 414.434 73.0041 413.676 70.2928H405.711C406.431 72.9884 406.804 75.1106 406.81 77.2351C406.816 79.3597 406.455 81.4818 405.712 84.1774H413.676C414.443 81.466 414.821 79.3491 414.818 77.235Z",
    fill: "#003792",
    stroke: "#003792",
    strokeWidth: 0.182692
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 388.876,
    y: 70.1101,
    width: 10.4135,
    height: 14.0673,
    fill: "#003792",
    stroke: "#003792",
    strokeWidth: 0.182692
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M378.958 23.6089L379.434 23.4435L379.503 22.9441C380.408 16.3572 386.06 11.2832 392.896 11.2832C400.362 11.2832 406.415 17.3359 406.415 24.8024C406.415 32.2689 400.362 38.3216 392.896 38.3216C386.25 38.3216 380.722 33.5253 379.589 27.2052L379.5 26.7091L379.018 26.5633C378.379 26.3703 377.915 25.7765 377.915 25.0764C377.915 24.3985 378.35 23.8201 378.958 23.6089Z",
    fill: "white",
    stroke: "#003792",
    strokeWidth: 1.64423
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 400.02,
    cy: 20.2352,
    r: 1.55305,
    fill: "#003792"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M399.497 23C399.771 23 400.001 23.2031 400 23.4775C399.997 24.5386 399.651 27 396.5 27C393.349 27 393.003 24.5386 393 23.4775C392.999 23.2031 393.229 23 393.503 23H399.497Z",
    fill: "#003792"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 391.434,
    cy: 20.2352,
    r: 1.55305,
    fill: "#003792"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M388.579 44.3561L388.579 44.3566L388.581 44.364C388.583 44.3722 388.586 44.386 388.59 44.405C388.597 44.4431 388.609 44.5022 388.623 44.5794C388.65 44.7341 388.684 44.9604 388.711 45.2371C388.765 45.7948 388.787 46.5354 388.67 47.2971C388.552 48.0603 388.3 48.8053 387.839 49.4126C387.388 50.0054 386.704 50.5125 385.628 50.7668C382.821 51.4299 380.196 53.812 378.526 56.7703C376.848 59.7444 376.043 63.4611 377.071 66.9302C377.907 69.7544 379.621 72.0822 381.825 73.7019L382.206 73.9821L382.64 73.7931C383.107 73.5896 383.9 73.2961 384.627 73.2437C384.986 73.2177 385.269 73.2559 385.472 73.3428C385.65 73.4192 385.796 73.5439 385.9 73.789C386.107 74.2758 386.052 74.5555 385.952 74.7677C385.821 75.0478 385.572 75.3028 385.186 75.6774C385.166 75.6964 385.146 75.716 385.125 75.7362C384.722 76.125 384.108 76.7176 383.957 77.5444C383.847 78.1497 383.873 78.7044 384.037 79.2089C384.201 79.7134 384.488 80.1192 384.827 80.4499C385.453 81.0612 386.324 81.4665 387.04 81.8001C387.061 81.8101 387.083 81.8199 387.104 81.8297C387.715 82.1146 388.235 82.3599 388.646 82.6584C389.043 82.9457 389.269 83.2341 389.363 83.5739C389.405 83.7276 389.379 83.7919 389.36 83.8272C389.329 83.8834 389.244 83.987 389.023 84.1064C388.565 84.3541 387.786 84.53 386.774 84.6019C384.778 84.7437 382.294 84.456 380.79 84.0263L380.564 84.8168L380.79 84.0263C379.931 83.7809 379.244 83.4745 378.704 83.1677L378.682 83.1554L378.66 83.1444C373.159 80.4471 368.764 75.5468 366.887 69.2115C363.387 57.3959 368.68 45.2408 380.13 41.3889C384.119 40.1776 386.168 41.0676 387.226 42.0349C387.783 42.5432 388.123 43.1233 388.324 43.5822C388.424 43.8104 388.488 44.004 388.525 44.1362C388.544 44.2021 388.556 44.2522 388.563 44.283C388.567 44.2984 388.569 44.3089 388.57 44.3141C388.57 44.3152 388.571 44.3161 388.571 44.3167C388.571 44.3175 388.571 44.3179 388.571 44.3179L388.574 44.3351L388.579 44.3552L388.579 44.3557L388.579 44.356L388.579 44.3561Z",
    fill: "white",
    stroke: "#003792",
    strokeWidth: 1.64423
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 399.931,
    cy: 14.0794,
    rx: 3.19711,
    ry: 2.19231,
    transform: "rotate(23.2182 399.931 14.0794)",
    fill: "#003792"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M403.347 14.9044L402.638 15.7262L401.52 14.8061L402.332 13.8203L403.347 14.9044Z",
    fill: "#003792"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M397.295 12.3758L397.836 13.4792L398.817 12.415L397.99 11.5689L397.295 12.3758Z",
    fill: "#003792"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M403.145 14.3529C402.983 14.7307 402.593 15.0236 402.004 15.1404C401.418 15.2568 400.68 15.184 399.942 14.8675C399.205 14.5511 398.644 14.0668 398.324 13.5616C398.002 13.0542 397.946 12.57 398.108 12.1922C398.27 11.8143 398.66 11.5215 399.249 11.4046C399.836 11.2883 400.573 11.3611 401.311 11.6775C402.048 11.9939 402.61 12.4782 402.93 12.9835C403.251 13.4909 403.307 13.975 403.145 14.3529Z",
    fill: "white",
    stroke: "#003792",
    strokeWidth: 0.913461
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 389.67,
    cy: 14.2599,
    rx: 3.19711,
    ry: 2.19231,
    transform: "rotate(-13.3909 389.67 14.2599)",
    fill: "#003792"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M392.904 12.8852L392.824 13.9679L391.379 13.8956L391.442 12.6202L392.904 12.8852Z",
    fill: "#003792"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M386.538 14.4645L387.63 15.0278L387.783 13.5884L386.615 13.402L386.538 14.4645Z",
    fill: "#003792"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M392.413 12.5626C392.508 12.9626 392.37 13.43 391.967 13.8751C391.566 14.3184 390.93 14.6998 390.149 14.8857C389.368 15.0715 388.629 15.0174 388.071 14.8026C387.511 14.5869 387.177 14.2319 387.081 13.8319C386.986 13.432 387.124 12.9645 387.528 12.5194C387.929 12.0762 388.565 11.6948 389.345 11.5089C390.126 11.323 390.865 11.3771 391.423 11.5919C391.984 11.8076 392.318 12.1627 392.413 12.5626Z",
    fill: "white",
    stroke: "#003792",
    strokeWidth: 0.913461
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M387.355 15.092C383.273 16.5397 381.169 18.1346 379.434 23.4327",
    stroke: "#003792",
    strokeWidth: 0.913461
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M391.708 14.5069C393.741 13.6679 395.121 13.4589 397.823 14.3342",
    stroke: "#003792",
    strokeWidth: 0.913461
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M661.277 125.732C661.277 127.968 648.609 117.216 641.264 120.197C633.919 123.177 627 125.413 627 121.687C627 117.961 636.474 112.426 645.948 113.703C655.422 114.981 661.277 123.816 661.277 125.732Z",
    fill: "#6B9EDA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M663.836 129.251C663.836 129.251 667.704 135.18 666.658 131.811C665.612 128.442 661.412 124.791 660.578 125.05C659.744 125.308 662.593 129.38 663.639 132.749C665.113 136.263 664.358 129.429 663.836 129.251Z",
    fill: "#6B9EDA"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 629.83,
    cy: 118.888,
    rx: 1.17095,
    ry: 0.425802,
    transform: "rotate(-28.074 629.83 118.888)",
    fill: "white"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 637.28,
    cy: 114.513,
    rx: 3.61931,
    ry: 0.851603,
    transform: "rotate(-29.2723 637.28 114.513)",
    fill: "#6B9EDA"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 638.179,
    cy: 120.735,
    rx: 3.61931,
    ry: 0.851603,
    transform: "rotate(0.102212 638.179 120.735)",
    fill: "#6B9EDA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M180.283 126.687C179.106 128.587 195.537 126.121 200.21 132.523C204.884 138.926 209.588 144.471 211.55 141.304C213.513 138.137 208.375 128.441 199.649 124.537C190.923 120.632 181.293 125.058 180.283 126.687Z",
    fill: "#6B9EDA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M176.254 128.33C176.254 128.33 169.844 131.333 172.507 129.02C175.17 126.708 180.664 125.816 181.237 126.475C181.809 127.134 177.243 129.094 174.58 131.407C171.475 133.618 175.717 128.207 176.254 128.33Z",
    fill: "#6B9EDA"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.17095,
    ry: 0.425802,
    transform: "matrix(-0.502125 -0.864795 -0.864795 0.502125 210.619 137.434)",
    fill: "white"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.61931,
    ry: 0.851603,
    transform: "matrix(-0.483929 -0.875107 -0.875107 0.483929 206.591 129.79)",
    fill: "#6B9EDA"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.61931,
    ry: 0.851603,
    transform: "matrix(-0.850966 -0.525221 -0.525221 0.850966 202.549 134.606)",
    fill: "#6B9EDA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandingOnIsland);
export default __webpack_public_path__ + "static/media/standing-on-island.b7a2bdde.svg";
export { ForwardRef as ReactComponent };